import React from "react";
import "./HImageBlurb.scss";
import PropTypes from "prop-types";

export const HImageBlurb = ({
  title,
  copy,
  list,
  image,
  placement = "left",
  style,
  className = "",
}) => {
  return (
    <section
      className={`hireart-ds-image-blurb hireart-ds-image-blurb-${placement} ${className}`}
      style={style}
    >
      <section className="hireart-ds-image-blurb-copy">
        <section>
          <h2>{title}</h2>
          {list && (
            <ul>
              {list.map((li, i) => (
                <li key={i}>{li}</li>
              ))}
            </ul>
          )}
          {copy || ""}
        </section>
      </section>
      <section className="hireart-ds-image-blurb-image">
        {image && <img src={image} />}
      </section>
    </section>
  );
};

HImageBlurb.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.any,
  list: PropTypes.array,
  image: PropTypes.string,
  placement: PropTypes.string,
  style: PropTypes.any,
};

